import React from 'react';

function InfoBlock({ text, isCardsGame }) {
  return (
    <div className='cpt-round-info-block'>
      <p className='cpt-round-title'>{text}</p>
      {isCardsGame && (
        <div className='upcoming-cards-wrapper'>
          <div className='upcoming-cards-inner' />
        </div>
      )}
    </div>
  );
}

export default InfoBlock;
